// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2mG0Y","header":"MessagesList_header__3dSVb","chat":"MessagesList_chat__2Ikra"};